import isEqual from 'lodash/isEqual';
import PosthogService from '../../services/posthog/PosthogService';

const STORAGE_KEY_PREFIX = 'posthog_identify_';

const getStorageKey = (userId) => `${STORAGE_KEY_PREFIX}${userId}`;

/**
 * Build user properties for PostHog identify calls.
 */
export const buildUserProperties = (user) => ({
  email: user.email_id,
  name: user.full_name,
  environment: process.env.REACT_APP_TEMP_MEE_ENV || 'development',
});

/**
 * Identify the user with PostHog only if their properties have changed
 * since the last identify call. This avoids redundant /decide API calls
 * when properties haven't changed (e.g. on page refresh).
 */
export const posthogIdentifyIfChanged = (user) => {
  if (!user?.id) return false;

  const currentProperties = buildUserProperties(user);
  const storageKey = getStorageKey(user.id);

  try {
    const stored = localStorage.getItem(storageKey);
    const lastProperties = stored ? JSON.parse(stored) : null;

    if (lastProperties && isEqual(lastProperties, currentProperties)) {
      return false;
    }
  } catch {
    // Storage read failed - proceed with identify
  }

  PosthogService.getInstance().identify(user.id, currentProperties);

  try {
    localStorage.setItem(storageKey, JSON.stringify(currentProperties));
  } catch {
    // Storage write failed - non-critical
  }

  return true;
};

/**
 * Clear the cached identify properties on logout.
 */
export const clearPosthogIdentifyCache = (userId) => {
  if (userId) {
    try {
      localStorage.removeItem(getStorageKey(userId));
    } catch {
      // Non-critical
    }
  }
};
